export default __webpack_public_path__ + "static/media/cancel-button.56b922fb.svg";